import { useMemo } from "react"

import { useAppSelector } from "store/hooks"
import { ApiTypes } from "types"

import { UserRole } from "utils/checkRoleType"
import { isRestrictedSubscriptionPlan } from "utils/isRestrictedSubscriptionPlan"

const COUNTRY_ID_TO_NAME_MAPPING: Record<number, string> = {
  1: "United States",
  2: "Canada",
  3: "Australia",
}

export const useUserProfile = () => {
  const userProfile = useAppSelector(state => state.user.userProfile)

  const userRole = userProfile?.type ?? 0

  const isEnterprise = [UserRole.EnterpriseManager].includes(userRole)

  const isContractor = [
    UserRole.ContractorAdmin,
    UserRole.ContractorManager,
    UserRole.ContractorEngineer,
    UserRole.ContractorTechnician,
  ].includes(userRole)

  const isSubscriptionPlanRestricted = isRestrictedSubscriptionPlan(userProfile)

  const enterpriseContractorIds = userProfile?.enterprise?.contractor_ids ?? []

  const enterpriseCountry = useMemo<ApiTypes.Model.Country | undefined>(() => {
    const country = userProfile?.enterprise?.country
    if (country) return country

    const countryId = userProfile?.enterprise?.state?.country_id
    if (countryId) {
      const countryName = countryId in COUNTRY_ID_TO_NAME_MAPPING ? COUNTRY_ID_TO_NAME_MAPPING[countryId] : undefined
      return { id: countryId, name: countryName ?? "" }
    }

    return undefined
  }, [userProfile?.enterprise?.country, userProfile?.enterprise?.state?.country_id])

  return {
    userProfile,
    userRole,
    isContractor,
    isSubscriptionPlanRestricted,
    // ENTERPRISE
    isEnterprise,
    enterpriseContractorIds,
    enterpriseCountry,
  }
}
